// extracted by mini-css-extract-plugin
export default {"root":"GRCountryFlag_root__QI67U","small":"GRCountryFlag_small__ESgFE","medium":"GRCountryFlag_medium__6dXIp","large":"GRCountryFlag_large__LZtvC"};